import React from "react";
import Image from "next/image";
import { TrustedByTopBrands, TopBrandCard } from "@/.storyblok/types/319751/storyblok-components";
import Testimonial from "@/components/Testimonial";
import { SbBlokData, storyblokEditable } from "@storyblok/react";

interface TrustedByTopBrandsProps {
  blok?: TrustedByTopBrands & SbBlokData;
}

const TrustedByTopBrandsComponent: React.FC<TrustedByTopBrandsProps> = ({ blok }) => {
  if (!blok) return null;

  const { top_brands, testimonials, title, type } = blok;

  const renderBrand = (brand: TopBrandCard) => {
    const hasImage = brand.image?.filename;
    // const altText = brand.alt_text || "Brand Logo";

    if (!hasImage) return null; // Skip rendering if the image is missing

    return (
      <div className="col-auto" key={brand._uid}>
        {brand.image?.filename && (
          <Image
            src={brand.image.filename}
            width={150}
            height={75}
            alt={brand.alt_text || "Brand Logo"}
            sizes="(max-width: 768px) 100vw, (max-width: 1200px) 50vw, 33vw"
            loading="lazy"
            quality={75}
          />
        )}
      </div>
    );
  };

  return (
    <div {...storyblokEditable(blok)} className="section-brands bg-white py-4 py-md-5">
      <div className="container">
        <h2 className="text-center text-primary">{title}</h2>
        {type === "trusted" && (
          <p className="mb-4 fw-bold text-center small text-uppercase">
            Rated 5 stars on Google
            <span className="text-gold ms-2">
              {[...Array(5)].map((_, index) => (
                <i key={index} className="fas fa-star me-1" />
              ))}
            </span>
          </p>
        )}

        {top_brands && (
          <div className="row justify-content-center align-items-center g-3 g-sm-4 mb-5">
            {top_brands.map((brand) =>
              brand.component === "top_brand_card" ? renderBrand(brand as TopBrandCard) : null,
            )}
          </div>
        )}

        {testimonials && <Testimonial hideHeading={true} testimonials={testimonials} />}
      </div>
    </div>
  );
};

export default TrustedByTopBrandsComponent;